import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-upload',
	templateUrl: './icon-upload.component.svg',
})
export class IconUploadComponent {}
